import { getRouteUrl } from '@nackle/service-urls';

export const idUrl = getRouteUrl( 'ID_PROVIDER' );
export const rosterUrl = getRouteUrl( 'ROSTER_PROXY' );
export const cmxUrl = getRouteUrl( 'CMX_V2' );
export const harryUrl = getRouteUrl( 'HARRY' );
